import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTimeline } from '../../store/timeline/timelineSlice';
import TimelineCard from '../TimelineCard';
import { useTranslation } from 'react-i18next';
import styles from './AssessmentHistory.module.scss';
const AssessmentHistory = () => {
    const { t } = useTranslation('translation', {
        keyPrefix: 'ASSESSMENT_HISTORY'
    });
    const dispatch = useDispatch();
    const { patientId } = useSelector((state) => state.smart);
    const { milestones, loading: isLoading } = useSelector((state) => state.timeline);
    const completedMilestones = useMemo(() => {
        if (!milestones || milestones.length === 0)
            return [];
        const completed = milestones.filter((m) => m.completed).sort((a, b) => b.displayOrder - a.displayOrder);
        // ✅ If none completed → show displayOrder 1 milestone only
        if (completed.length === 0) {
            const firstMilestone = milestones.find((m) => m.displayOrder === 1);
            return firstMilestone ? [firstMilestone] : [];
        }
        return completed;
    }, [milestones]);
    useEffect(() => {
        if (!patientId) {
            return;
        }
        dispatch(fetchTimeline(patientId));
    }, [patientId, dispatch]);
    if (isLoading) {
        return (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                gap: 2,
                p: 3
            }, children: [_jsx(CircularProgress, { size: 60 }), _jsx(Typography, { variant: "h6", color: "text.secondary", children: t('LOADING') })] }));
    }
    return (_jsxs(Box, { className: styles.wrapper, children: [_jsx(Box, { className: styles.header, children: _jsx(Typography, { variant: "h3", children: t('TITLE') }) }), _jsx(Box, { className: styles.content, children: _jsx(Box, { className: styles.timeline_container, children: completedMilestones.map((milestone, index) => (_jsx(TimelineCard, { milestone: milestone, isFirst: index === 0, isLast: index === completedMilestones.length - 1 }, milestone.id || milestone.milestoneCode))) }) })] }));
};
export default AssessmentHistory;
